<template>
<div style="height:100%">
  <Navigation/>
  <router-view/>
</div>
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue';
import axios from 'axios';
import Utils from '@/utils.js';

export default {
  name: 'HomeView',
  components: {
    Navigation
  },

  created() {
    // periodic health check, every 4 minutes
    setInterval(function() {
      axios.get(Utils.getURL('/healthcheck'))
      .then()
      .catch((error)=>{
        // TODO: if the error is because of unathentication, redirect to login page
        console.log(error);
      })

    }, 240000);
  }
}
</script>
